import {
  INSURANCE_ADDED,
  INSURANCE_DELETED,
  INIT_INSURANCES,
  TOGGLE_TERMS,
} from 'Store/booking/proposals/constants';

export type InsuranceEntry = {
  termsChecked: boolean;
  isAdded: boolean;
  isDeleted: boolean;
};

export type InsuranceState = Record<string, InsuranceEntry>;

const emptyEntry = (): InsuranceEntry => ({
  termsChecked: false,
  isAdded: false,
  isDeleted: false,
});

const initialState: InsuranceState = {};

export const insuranceReducer = (
  state: InsuranceState = initialState,
  action: Action<InsuranceState | string>,
): InsuranceState => {
  const payload = action.payload;

  switch (action.type) {
    case INIT_INSURANCES:
      return (payload as InsuranceState) ?? initialState;

    case INSURANCE_ADDED: {
      const insuranceId = payload as string;
      return {
        ...state,
        [insuranceId]: {
          ...(state[insuranceId] ?? emptyEntry()),
          isDeleted: false,
          isAdded: true,
        },
      };
    }

    case INSURANCE_DELETED: {
      const insuranceId = payload as string;
      return {
        ...state,
        [insuranceId]: {
          ...(state[insuranceId] ?? emptyEntry()),
          isAdded: false,
          isDeleted: true,
        },
      };
    }

    case TOGGLE_TERMS: {
      const insuranceId = payload as string;
      const current = state[insuranceId] ?? emptyEntry();
      return {
        ...state,
        [insuranceId]: {
          ...current,
          termsChecked: !current.termsChecked,
        },
      };
    }

    default:
      return state;
  }
};
